import React from "react";
import DealNotificationModel from "../../viewModels/Notification/DealNotificationModel";
import DealNotificationListItem from "./components/DealNotificationListItem";
import { Divider, Empty, Space, Spin } from "antd";
import { useSelector } from "react-redux";
import { makeSelectDealNotificationsLoadingData } from "../../containers/App/selectors";
import { OFFICE_TYPES } from "../../dto/Company/CompanySettingsDto";

type Props = {
  notifications: Array<DealNotificationModel>;
  adminOfficeType?: OFFICE_TYPES;
};

const DealNotificationsList = React.memo(({ notifications, adminOfficeType }: Props) => {
  const loading = useSelector(makeSelectDealNotificationsLoadingData());
  return (
    <Spin spinning={loading} delay={100}>
      {notifications.length > 0 ? (
        <Space orientation="vertical" style={{ width: "100%" }} separator={<Divider />} size={0}>
          {notifications.map((x) => (
            <DealNotificationListItem key={`${x.officeType}:${x.id}`} notification={x} adminOfficeType={adminOfficeType} />
          ))}
        </Space>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Spin>
  );
});

export default DealNotificationsList;
